// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.WaterfallChartConfiguration.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
import cfgFactories from 'share/factories/Izenda.ReportPartStyleConfigurationFactories';
import localizer from 'share/localization/Izenda.Localizer';
import WaterfallChartOptionsBuilder from './Izenda.WaterfallChartOptionsBuilder';

import { REPORT_PART_TYPE } from 'logic/data/Izenda.ReportDesignerConstants';
import { createXAxisSchema, createYAxisSchema, createTotalLabelSchema } from '../FieldContainers/Izenda.FieldContainerSchemaFunctions';
import { MappingValues, CHART_TYPE } from 'logic/data/Izenda.ChartDefaultConfig';
import VISUAL_TYPE from 'share/components/charting/highcharts/Izenda.VisualTypeMapping';

const { STACK_TYPE_CHART_VALUES, STEP_TYPE_VALUES, ZOOM_TYPE_VALUES, LINE_STYLE_VALUES } = MappingValues;

cfgFactories.extendConfiguration(REPORT_PART_TYPE.Chart, CHART_TYPE.Waterfall, null, {
  visualType: VISUAL_TYPE.Waterfall,

  get visualLabel() {
    return localizer.getText('REPORT_CHART_TYPE_WATERFALL');
  },

  visualPreviewCSS: 'chart-water',

  optionsBuilder: WaterfallChartOptionsBuilder,

  /**
   * The array function to create chart back-side fields containers.
   */
  fieldContainerSchema: [createXAxisSchema(1), createYAxisSchema(1), createTotalLabelSchema],

  optionsMapping: {
    optionsByType: {
      izInverted: { propKey: 'chart.inverted', defaultValue: false },
      izValueLabel: { propKey: 'plotOptions.series.dataLabels.enabled', defaultValue: false },
      legendSettings: { defaultValue: true },
      izZoom: { propKey: 'chart.zoomType', propSource: ZOOM_TYPE_VALUES, defaultValue: undefined },
      izMultiColor: { defaultValue: false },
      izLabelOrientation: { defaultValue: undefined },
      izLabelOrientationX: { defaultValue: undefined },
      izLabelOrientationY: { defaultValue: undefined },

      izXYplane: { defaultValue: undefined },
      izGridline: { defaultValue: undefined },
      izThresholds: { defaultValue: undefined },

      izTotalLabel: { defaultValue: undefined }
    }
  }
});



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartChart/Izenda.WaterfallChartConfiguration.js